import React from "react"

import Layout from "../Components/layout"
import PostList from "../Components/postlist"


const Page = () => {
    return (
        <div>
            <Layout>
                <PostList />
            </Layout>
        </div>
    )
}
export default Page;
